// The packhouse's inbox of farm loads that nobody has answered yet.
//
// ONE query, shared by the citrus inbox (PendingFarmLoads, on /deliveries) and
// the berry inbox (BerryFarmLoadsInbox, on the berry intake page). Both read the
// same react-query key, so a receive on either side refreshes both.
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { POLL } from '@/lib/pollTiers'

export interface PendingFarmLoad {
  load_id:             string
  container_label:     string
  container_count:     number
  crate_count:         number | null
  estimated_kg:        number | null
  vehicle_ref:         string | null
  notes_for_packhouse: string | null
  block_id:            string | null
  commodity_id:        string | null
  variety:             string | null
  submitted_at:        string
  grower_id:           string
}

const COLS = 'load_id, container_label, container_count, crate_count, estimated_kg, vehicle_ref, notes_for_packhouse, block_id, commodity_id, variety, submitted_at, grower_id'

function pendingFarmLoadsKey(tenantId: string | null) {
  return ['pending-farm-loads', tenantId] as const
}

export function usePendingFarmLoads(tenantId: string | null) {
  return useQuery({
    queryKey: pendingFarmLoadsKey(tenantId),
    enabled:  !!tenantId,
    refetchInterval: POLL.standard,
    queryFn: async (): Promise<PendingFarmLoad[]> => {
      const { data, error } = await supabase.from('farm_packhouse_loads')
        .select(COLS).eq('status', 'PENDING').eq('packhouse_tenant_id', tenantId!).is('deleted_at', null)
        .order('submitted_at', { ascending: true })
      if (error) throw error
      return (data ?? []) as PendingFarmLoad[]
    },
  })
}
